export default {"src":"/_next/static/media/tablet1.18afb3e9.svg","height":365,"width":353};